// $('.latest-video-slide').slick({
// 	  slidesToShow: 4,
// 	  slidesToScroll: 1,
// 	  autoplay: true,
// 	  arrows: false,
// 	  autoplaySpeed: 2000,
// 	  responsive: [
// 	    {
// 	      breakpoint: 821,
// 	      settings: {
	       
// 	        slidesToShow: 3,
// 	        arrows: true
// 	      }
// 	    },
// 	    {
// 	      breakpoint: 575,
// 	      settings: {
	        
// 	        slidesToShow: 2,
// 	        arrows: true
// 	      }
// 	    }
//   	 ]
// 	});

$(document).ready(function(){

	// top product description js start // 

		$('.slider-prdImg-main').slick({
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  arrows: true,
		  fade: false,
			infinite: false,
			draggable:false,
			speed:700,
		  asNavFor: '.slider-thumb-prd',
		    arrows: false,
		    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
		    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
		});
		$('.slider-thumb-prd').slick({
		  slidesToShow: 3,
		  slidesToScroll: 1,
		  asNavFor: '.slider-prdImg-main',
		  dots: false,
		  centerMode: false,
		  focusOnSelect: true
		});

	// top product description js end // 


	// light box slide js start //
		jQuery('.slider-prdImg-main .prd-main-item').click(function(){
					var tab_id_business = jQuery(this).attr('data-tab');

					jQuery('.slider-prdImg-main .prd-main-item').removeClass('product-lightBox-current');
					jQuery('.custom-popup-light').removeClass('product-lightBox-current');

					jQuery(this).addClass('product-lightBox-current');
					jQuery('#'+tab_id_business).addClass('product-lightBox-current');
		});



		$('.popup-lightBox-close').click(function(){

			$('.custom-popup-light').removeClass('product-lightBox-current');

		});

		$('.lightBox-slide-item-arow').click(function(){

			$('.custom-img-zoom').toggleClass('img-zoom-lance');
			$(this).toggleClass('item-arow-move');

		});

		$('.slick-arrow').click(function(){

			$('.custom-img-zoom').removeClass('img-zoom-lance');
			$('.lightBox-slide-item-arow').removeClass('item-arow-move');

		});
	// light box slide js end //

	$('.hamburger-menu-icon').click(function(){
	
		$(this).toggleClass('hamburger-menu-iconMobile');
		$('.mobile-menu').toggleClass('mobile-menu-show');
		$('body').toggleClass('overflow-hidden');

	});		


});


// product item increase and decrease js start //

	var buttonPlus  = $(".qty-btn-plus");
		var buttonMinus = $(".qty-btn-minus");

		var incrementPlus = buttonPlus.click(function() {
		  var $n = $(this)
		  .parent(".qty-container")
		  .find(".input-qty");
		  $n.val(Number($n.val())+1 );
		});

		var incrementMinus = buttonMinus.click(function() {
		  var $n = $(this)
		  .parent(".qty-container")
		  .find(".input-qty");
		  var amount = Number($n.val());
		  if (amount > 0) {
		    $n.val(amount-1);
		  }
		});

// product item increase and decrease js end //




$('.product-lightBox-slide').slick({
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll:1
});	



